import * as React from 'react'
import { Container } from '../Container'
import { GraySection } from '../GraySection'

import brakeIcon from '../../../public/img/icons/brake-icon-black.png'
import receiptDiscountIcon from '../../../public/img/icons/receipt-discount-icon-black.png'
import clockIcon from '../../../public/img/icons/clock-icon-black.png'
import documentIcon from '../../../public/img/icons/document-icon-black.png'
import likeShapedIcon from '../../../public/img/icons/like-shaped-icon-black.png'
import shieldTickIcon from '../../../public/img/icons/shield-tick-icon-black.png'

import Image from 'next/image'

const ITEM_ICONS = [brakeIcon, receiptDiscountIcon, clockIcon, documentIcon, likeShapedIcon, shieldTickIcon]

const defaultItems = [
  { title: 'FREE ($79 Value)', description: 'Brake Inspection' },
  { title: 'UP TO $50 OFF', description: 'Any Future Repair' },
  { title: '20 MINS', description: 'To Complete Inspection' },
  { title: 'DIGITAL INSPECTION', description: 'Detailed Brake Report' },
  { title: '100%', description: 'Satisfaction Guarantee' },
  { title: '2 YEAR / 24,000', description: 'MILE Warranty' },
]

type Props = {
  title: string
  description?: string
  items?: { title: string; description: string }[]
}

export const IncludedWithInspectionSection: React.FC<Props> = ({ title, description, items: itemsProp }) => {
  const items = itemsProp ?? defaultItems
  return (
    <GraySection className="pt-[5%] xl:py-20 text-center">
      <Container className="max-w-screen-lg">
        <div>
          <h2 className="title text-2xl sm:text-3xl md:text-4xl">{title}</h2>
          {description && <p className="description text-black">{description}</p>}
        </div>
        <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {items.map((item, index) => (
            <IncludedWithInspectionItem
              key={index}
              title={item.title}
              description={item.description}
              iconSource={ITEM_ICONS[index]}
            />
          ))}
        </div>
      </Container>
    </GraySection>
  )
}

const IncludedWithInspectionItem: React.FC<{
  title: string
  description: string
  iconSource?: any
}> = ({ title, description, iconSource }) => {
  return (
    <div
      className="py-4 bg-white flex flex-col items-center justify-center text-center  px-6"
      style={{ border: '1px solid #dddddd' }}
    >
      <div className="w-[60px] h-[60px] flex flex-row rounded-full items-center justify-center">
        <Image src={iconSource} height={40} width={40} alt="shield security icon" />
      </div>
      <div className="mt-3">
        <h3 className="text-lg text-primary">{title}</h3>
        <p className="description text-black">{description}</p>
      </div>
    </div>
  )
}
